import { api, apiSdk } from '@/api/sdk';

export type Bundle = {
  data: unknown; themeCss: string; customCss: string; meta: unknown;
};

export type SiteContentResponse = Bundle & { base_ref: string; branch: 'main' };

export const fetchTemplateBundle = (
  templateId: string,
): Promise<Bundle> =>
  api.get(`/api/templates/${encodeURIComponent(templateId)}`);

export const fetchSiteContent = (siteId: string): Promise<SiteContentResponse> =>
  api.get(`/api/sites/${encodeURIComponent(siteId)}/content`);

export const publishSite = (
  siteId: string,
  bundle: Bundle,
): Promise<{ status: string }> =>
  api.put(`/api/sites/${encodeURIComponent(siteId)}`, { bundle });

export const createSiteFromBundle = (
  templateId: string,
  subdomain: string,
  title: string,
  bundle: Bundle,
): Promise<{ site_id: string }> =>
  api.post('/api/sites', { template_id: templateId, subdomain, title, bundle });

export const uploadImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);
  const data = await apiSdk.request<{ url: string; objectKey: string }>(
    '/api/uploads',
    { method: 'POST', body: formData },
  );
  return data.url;
};
